import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, limit } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';
import LazyLoad from 'react-lazyload';
import debounce from 'lodash.debounce';

const VideoCard = ({ title, videoId }) => {
  return (
    <LazyLoad height={200} offset={100} once>
      <div className="col-md-4 mb-4">
        <div className="vw-video-card">
          <div className="ratio ratio-16x9">
            <iframe
              src={`https://www.youtube.com/embed/${videoId}`}
              title={title}
              allowFullScreen
              className="vw-rounded-top"
            ></iframe>
          </div>
          <div className="vw-card-body">
            <h5 className="vw-video-title">{title}</h5>
          </div>
        </div>
      </div>
    </LazyLoad>
  );
};

const Videolar = () => {
  const [videos, setVideos] = useState([]);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [limitCount, setLimitCount] = useState(6);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const videosQuery = query(collection(db, 'videos'), limit(limitCount));
        const videosSnapshot = await getDocs(videosQuery);
        const videosList = videosSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setVideos(videosList);
        setFilteredVideos(videosList);

        const uniqueCategories = [
          'All',
          ...new Set(videosList.map(video => video.category)),
        ];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error('Error fetching videos:', error);
      }
    };

    fetchVideos();
  }, [limitCount]);

  useEffect(() => {
    let result = videos;

    if (selectedCategory !== 'All') {
      result = result.filter(video => video.category === selectedCategory);
    }

    if (searchTerm) {
      result = result.filter(video =>
        video.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredVideos(result);
  }, [selectedCategory, searchTerm, videos]);

  // Debounced arama fonksiyonu
  const handleSearchChange = (e) => {
    const debouncedSearch = debounce((value) => {
      setSearchTerm(value);
    }, 300);
    debouncedSearch(e.target.value);
  };

  const loadMoreVideos = () => {
    setLimitCount(prev => prev + 6);
  };

  return (
    <div className="vw-container py-5">
      <h1 className="vw-gallery-title text-center mb-4">ENGLISH Warm-Up Songs</h1>
      <div className="vw-filter-section mb-4">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="vw-search-wrapper">
            <input
              type="text"
              className="vw-search-input form-control"
              placeholder="Search videos by title..."
              onChange={handleSearchChange}
            />
          </div>
          <div className="vw-filter-wrapper">
            <label htmlFor="vwCategoryFilter" className="vw-filter-label form-label me-2">
              Filter by Category:
            </label>
            <select
              id="vwCategoryFilter"
              className="vw-filter-select form-select"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              {categories.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="row">
        {filteredVideos.length > 0 ? (
          filteredVideos.map((video) => (
            <VideoCard
              key={video.id}
              title={video.title}
              videoId={video.videoId}
            />
          ))
        ) : (
          <div className="col-12 text-center">
            <p className="vw-no-results">No videos found.</p>
          </div>
        )}
      </div>
      {filteredVideos.length >= limitCount && (
        <div className="text-center mt-4">
          <button className="vw-load-more-btn btn" onClick={loadMoreVideos}>
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default Videolar;